import { useState } from 'react';
import { I18n } from 'i18n';
import { Button } from 'antd';
import { Toast } from 'components';
import useComponents from 'hooks/useComponents';
import { notificationsConfigure } from 'apollo/configuration';

export function Save({ customer, selectedChannel, onCloseDrawer, onSuccess }) {
  const [isLoading, setLoading] = useState(false);
  const {
    configuration: { notifications },
  } = useComponents();

  const handleClick = async () => {
    setLoading(true);
    try {
      const isWhatsApp = selectedChannel === 'whatsapp';
      const variables = {
        _id: customer._id,
        ...(isWhatsApp
          ? {
              waGroupId: notifications?.waGroupId || '',
              waNotifications: notifications?.waNotifications ?? false,
            }
          : {
              tgGroupId: notifications?.tgGroupId || '',
              tgNotifications: notifications?.tgNotifications ?? false,
            }),
      };

      const { data, error, message } = await notificationsConfigure(variables);

      if (error) {
        Toast.error({ key: 'error-save-notifications', message: I18n(message || 'error', true) });
      } else if (data) {
        onCloseDrawer();
        onSuccess?.(data);
        Toast.success({
          key: 'success-save-notifications',
          message: I18n('your_changes_were_saved_successfully', true),
        });
      }
    } catch (err) {
      Toast.error({
        key: 'error-save-notifications',
        message: I18n('internal_server_error', true),
      });
    }
    setLoading(false);
  };

  return (
    <Button type="primary" className="rk-button-primary" loading={isLoading} onClick={handleClick}>
      {I18n('save_changes', true)}
    </Button>
  );
}
